<template>
    <div>
        <div class="list">
            <div class="list-item">
                <div class="title">
                    <span>限价卖出</span>
                    <span>伦敦金 3.00手</span>
                </div>
                <ul>
                    <li>
                        <div class="left">
                            <p>订单号<span>20000000</span></p>
                            <p>挂单价<span>1325.00</span></p>
                            <p>成交价<span>1325.00</span></p>
                        </div>
                        <div class="right">
                            <p>成交时间<span>12：20：30</span></p>
                            <p>止损<span>1335.00</span></p>
                            <p>止盈<span>1305.00</span></p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components:{
        Headers
    },
    name:"transactions"
}
</script>

<style scoped>
    body{touch-action: none;}
    li{list-style: none;}
    .list{margin: 0 auto;padding: 0 12px;margin-top: 10px;}
    .list-item{background-color: #FFFFFF;border-radius: 12px;}
    .list-item .title{padding: 12px 12px 0 12px;display: flex;align-items: center;}
    .list-item .title span:nth-of-type(1){padding: 3.33px 6.67px; height: 18px;border-radius: 12px;background-color: #17CF84;display: flex;justify-content: center;align-items: center;color: #FFFFFF;font-size: 12px;}
    .list-item .title span:nth-of-type(2){color: #333333;font-size: 16px;font-weight: bold;padding-left: 6px;}
    .list-item ul{padding: 0 12px 19.33px 12px; display: flex;justify-content: flex-start;align-items: center;flex-wrap: wrap;position: relative;}
    .list-item ul li{display: flex;flex-wrap: wrap;}
    .list-item ul li p{padding-top: 12px;}
    .list-item ul li .left{color: #999999;font-size: 14px;}
    .list-item ul li .right{padding-left: 15px;color: #999999;font-size: 14px;}
    .list-item ul li .left span{padding-left: 8.67px;color: #333333;font-size: 14px;}
    .list-item ul li .right span{padding-left: 8.67px;color: #333333;font-size: 14px;}
</style>


// WEBPACK FOOTER //
// src/pages/transaction.vue